import React from "react";
import type { ReactNode } from "react";
import { s } from "../styles";
import { money } from "../helpers";

interface MoneyBoxProps {
  label: ReactNode;
  num: string;
  value: number | string | null | undefined;
}

export default function MoneyBox({ label, num, value }: MoneyBoxProps) {
  const { d, c } = money(value);
  return (
    <div style={{ ...s.mbox, flex: 1 }}>
      <div style={s.mlabel}>{label}</div>
      <div style={s.mfield}>
        <span style={s.mnum}>{num}</span>
        <span style={s.mval}>{d}</span>
        <span style={s.mcents}>{c}</span>
      </div>
    </div>
  );
}